// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2dNSv","header":"ReportDetails_header__2HPQL","title":"ReportDetails_title__2cb7j","left":"ReportDetails_left__3w76b"};